import React from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import createLogger from 'redux-logger'
import thunk from 'redux-thunk'

import Gradebook from './components/Gradebook'
import FilterForm from './components/FilterForm'

import { COURSENUM } from './actions'

/**
 * Redux Reducer.
 * @params:
 *  - state: the previous state of the store
 *  - action: an object describing how the state should change
 * @returns:
 *  - state: a new state after apply appropriate changes
 */
export const defaultState = {
  page: 1,
  isPercentFormat: false,
  coursenum: COURSENUM,
  isCanvasCourse: false,
  filters: {},
  loading: true,
  limit: 50,
  modal: {
    showModal: false,
    selectedActivity: {
      id: '',
      title: '',
    },
    modalBody: null,
  },
}

export const rootReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'UPDATE_GRADEBOOK':
      return {
        ...state,
        gradebook: action.payload,
        loading: false,
      }
    case 'UPDATE_ISCANVASCOURSE':
      return {
        ...state,
        isCanvasCourse: action.payload,
        loading: false,
      }
    case 'UPDATE_SECTIONS':
      return {
        ...state,
        sections: action.payload,
      }
    case 'CHANGE_PAGE':
      return {
        ...state,
        page: action.payload,
        loading: true,
      }
    case 'UPDATE_FILTERS':
      return {
        ...state,
        filters: action.payload,
      }
    case 'UPDATE_SCORE_FORMAT':
      return {
        ...state,
        isPercentFormat: action.payload,
      }
    case 'UPDATE_MODAL':
      return {
        ...state,
        modal: {
          ...state.modal,
          ...action.payload,
        },
      }
    default:
      return state
  }
}

/**
 * Redux Store object with three functions you should care about:
 *  - getState(): returns the current state of the store
 *  - dispatch(action): calls the reducer with a given action
 *  - subscribe(): called after a reducer runs
 *
 * The store has two additional middlewares to add some features:
 *  - redux-thunk: allows `store.dispatch()` to receive a thunk (function) or an object
 *                 See http://stackoverflow.com/questions/35411423/how-to-dispatch-a-redux-action-with-a-timeout/35415559#35415559
 *  - redux-logger: logs out redux store changes to the console. Only in dev.
 */
const middlewares =
  process.env.NODE_ENV === 'production'
    ? applyMiddleware(thunk)
    : applyMiddleware(thunk, createLogger())
let store = compose(middlewares)(createStore)(rootReducer)

/**
 * Helper function to render the Gradebook component to the DOM.
 * Makes the following props available to the Gradebook component:
 *  - storeState: an object of the latest state of the redux store.
 *  - dispatch: a function that dispatches actions to the store/reducer.
 */
const render = showAccountingButton => {
  let gradebookNode = document.getElementById('app')
  let filterNode = document.getElementById('filter_form_container')
  ReactDOM.render(
    <Provider store={store}>
      <Gradebook showAccountingButton={showAccountingButton} />
    </Provider>,
    gradebookNode
  )

  ReactDOM.render(
    <Provider store={store}>
      <FilterForm />
    </Provider>,
    filterNode
  )
}

/**
 * Function that bootstraps the Gradebook system.
 *  - render the Gradebook component with initial store state.
 *  - re-render the Gradebook component when the store changes.
 */
export let startGradebook = showAccountingButton => {
  render(showAccountingButton)
  store.subscribe(() => render(showAccountingButton))
}
